import { adRefCity } from './adRefTracking'

export const personalizedServingText = (path) => {
  const defaultText = 'Serving Sacramento & Bay Area'

  const specificText =
    path.includes('countertops') ||
    path.includes('kitchen') ||
    path.includes('bathroom') ||
    path.includes('shower') ||
    path.includes('roofing') ||
    path.includes('additions') ||
    path.includes('general')
      ? 'Serving Sacramento & Surrounding'
      : defaultText

  const cityText = adRefCity(specificText)

  return cityText === specificText ? specificText : cityText
}
